<template>
  <div
    ref="dropdownRef"
    :class="cssClassesComputed"
    @click="handleClickEvent"
  >
    <input
      :disabled="disabled"
      class="dropdown-arrow-control__input"
      type="checkbox"
      @blur="handleBlurEvent"
      @focus="handleFocusEvent"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const ENTER = 13

const props = defineProps({
  cssClasses: {
    type: Array,
    default: () => [],
  },
  defaultState: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click'])

const state = ref(props.defaultState === true)
const isFocused = ref(false)
const dropdownRef = ref(null)

const cssClassesComputed = computed(() => {
  return [
    'dropdown-arrow-control',
    state.value ? 'dropdown-arrow-control--on' : '',
    isFocused.value ? 'dropdown-arrow-control--focused' : '',
    ...props.cssClasses,
  ]
})

const handleClickEvent = () => {
  if (props.disabled) {
    return
  }

  state.value = !state.value
  emit('click', state.value)
}

const handleFocusEvent = () => {
  isFocused.value = true
  dropdownRef.value.addEventListener('keydown', handleKeyDownEvent)
}
const handleBlurEvent = () => {
  isFocused.value = false
  dropdownRef.value.removeEventListener('keydown', handleKeyDownEvent)
}
const handleKeyDownEvent = (event) => {
  if (event.keyCode === ENTER) {
    dropdownRef.value.click()
  }
}
</script>

<style lang="scss">
.dropdown-arrow-control {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  transition: transform 0.1s linear;
  -webkit-tap-highlight-color: transparent;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -6px;
    border: 12px solid transparent;
    border-top-color: $kds-color-background-accent;
    border-radius: 6px;
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -10px;
    border: 12px solid transparent;
    border-top-color: $kds-color-line-accent-inverse;
    border-radius: 6px;
  }

  &--on {
    transform: rotate(180deg);
  }

  &--focused {
    &::before {
      border-top-color: $kds-color-line-focus;
    }
  }

  &__input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    opacity: 0;
    cursor: pointer;
  }
}
</style>
